import { Outlet } from "react-router";
import SideNavigation from "../SideNavigation";
import TopNavigation from "../TopNavigation";
import { Inner, Main, Wrapper } from "./Layout.styles";
import { useAccountList } from "../../hooks/useAccountList";
import LoadingPage from "../../pages/LoadingPage";
import NoAccountsPage from "../../pages/NoAccountsPage";
import ErrorBoundary from "../ErrorBoundary";
import i18next from "../../localization/i18next";
import { useEffect } from "react";
import { useStore } from "../../store/store";

function Layout() {
  const language = useStore.useLanguageSettings();
  const { data: accounts, isLoading } = useAccountList(true);

  useEffect(() => {
    i18next.changeLanguage(language.iso639Code);

    document.documentElement.lang = language.iso639Code;
  }, [language]);

  if (isLoading) {
    return <LoadingPage />;
  }

  const hasAccounts = Boolean(accounts?.model.length);

  return (
    <Wrapper>
      <TopNavigation />
      <Inner>
        <SideNavigation />

        <Main id="main">
          <ErrorBoundary>
            {hasAccounts && <Outlet />}
            {!hasAccounts && <NoAccountsPage />}
          </ErrorBoundary>
        </Main>
      </Inner>
    </Wrapper>
  );
}

export default function LayoutWithErrorBoundary() {
  return (
    <ErrorBoundary>
      <Layout />
    </ErrorBoundary>
  );
}
